<template>
  <div>
    <span class="placeholder">{{ label }}</span>
    <v-select
      :key="renderKey"
      solo
      class="auc-type schedule-select"
      :value="value"
      :items="items"
      item-text="text"
      item-value="value"
      :id="fieldId"
      filled
      :label="label"
      hide-details
      height="44"
      style="height: 44px !important"
      @change="$emit('change', $event)"
    >
      <template v-slot:selection>
        <span class="schedule-select-selection-text">{{ displayedText }}</span>
      </template>
      <template v-slot:item="{ item, attrs, on }">
        <v-list-item v-bind="attrs" v-on="itemListeners(item, on)">
          <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-select>
  </div>
</template>

<script>
import { mergeScheduleSpecificItemListeners } from './scheduleSelectItemListeners';

export default {
  name: 'AuctionFormScheduleSelect',
  props: {
    renderKey: { type: String, required: true },
    value: { required: true },
    items: { type: Array, required: true },
    label: { type: String, required: true },
    fieldId: { type: String, required: true },
    displayedText: { type: String, required: true },
  },
  methods: {
    itemListeners(item, on) {
      return mergeScheduleSpecificItemListeners(item, on, () => {
        this.$nextTick(() => this.$emit('open-specific-dialog'));
      });
    },
  },
};
</script>

<style scoped>
.schedule-select ::v-deep .v-text-field__details {
  display: none;
}
</style>
